export const translationsVi = {
  _hide: 'Hide',
  _publish: 'Publish',
  _save: 'Lưu',
  _open: 'Mở',
  _close: 'Đóng',
  _delete: 'Xóa',
  _cancel: 'Hủy',
  _from: 'Từ',
  _to: 'Đến',
  _between_to: 'to',
  _search: 'Tìm kiếm',
  _successful: 'Thành công',
  _clearSuccessful: 'Thành công',
  _ok: 'Đồng ý',
  _edit: 'Sửa',
  _confirm: 'Xác nhận',
  _saveCompleted: 'Lưu thành công',
  _saveFailed: 'Lưu thất bại',
  _logout: 'Đăng xuất',
  _select: 'Vui lòng chọn',
  _upload_image: 'Tải ảnh',
  _upload_image_recommend_spec: 'Kích thước ảnh khuyến nghị là {image_size} và không vượt quà {file_size}',
  _resize_image_recommend_spec: 'Phóng to thu nhỏ có thể ảnh hướng đến chất lượng ảnh',
  _status: 'Trạng thái',
  _clear: 'Xóa',
  _manual: 'Hướng dẫn sử dụng',
  _click_here: 'Click',
  _baht: 'Baht',
  _preview: 'Xem trước',
  _add: 'Thêm',
  _import: 'Nhập',
  _sort: 'Lọc',
  _sort_by: 'Lọc theo',
  _move_to_top: 'Chuyển lên trên',
  _move_to_bottom: 'Chuyển xuống dưới',
  _custom: 'Tùy chỉnh',
  _pin: 'Ghim',
  _unpin: 'Bỏ ghim',
  _learn_more: 'Xem thêm',
  _firstname: 'Tên',
  _lastname: 'Họ',
  _add_field: 'Thêm mục',
  _free: 'Miễn phí',
  _product_name: 'Tên sản phẩm',
  _data: 'Data',
  _detail: 'Detail',
  _note: 'Note',
  _last_edited: 'Last edited',
  _by: 'By',
  product_buttons_label: 'Products list',
  Unauthorized: '401: Không khả dụng',
  menu_product: 'Sản phẩm',
  menu_order: 'Manage',
  menu_settings: 'Cài đặt',
  menu_max_products: 'Max Products',
  menu_max_products_unlimit: 'Unlimit',
  category: 'Hạng mục',
  category_add: 'Thêm sản phẩm',
  category_parent_category: 'Hạng mục chính',
  category_detail: 'Chi tiết',
  category_name: 'Tên hạng mục',
  category_validate_please_insert_a_category_name: 'Vui lòng nhập tên hạng mục',
  category_staticURL: 'Static URL',
  order_from: 'Đặt hàng từ ',
  order_ID: 'Mã đơn hàng',
  order_date: 'Ngày đặt hàng',
  order_shipping_address: 'Địa chỉ giao hàng',
  order_name: 'Tên',
  order_address: 'Địa chỉ',
  order_province: 'Tỉnh/ Thành Phố',
  order_country: 'Quốc gia',
  order_postcode: 'Mã bưu điện',
  order_tel: 'Sđt',
  order_email: 'Email',
  order_billing_address: 'Địa chỉ thanh toán',
  order_product_details: 'Thông tin sản phẩm',
  order_product: 'Sản phẩm',
  order_price: 'Giá',
  order_qty: 'Số lượng',
  order_total: 'Tổng cộng',
  order_type: 'Loại',
  order_type_cart: 'Đặt hàng',
  order_type_contact: 'Liên hệ',
  order_subtotal: 'Tổng phụ',
  order_shipping: 'Giao hàng',
  order_payment_method: 'Phương thức thanh toán',
  order_payment_method_Transfer: 'Chuyển khoản',
  order_payment_method_omise: 'Thẻ tín dụng',
  order_payment_method_kpayment_card: 'Thẻ tín dụng',
  order_payment_method_kpayment_qr: 'QR Code',
  order_remask: 'Ghi chú',
  order_create_date: 'Create Date',
  order_SKU: 'SKU',
  order_search_placeholder_select_date: 'Click để chọn ...',
  order_contact_form: 'Mẫu liên hệ',
  products_management: 'Quản lý sản phẩm',
  products_setup: 'Thiết lập sản phẩm',
  products_sorting: 'Lọc sản phẩm',
  products_management_sorting_options_select: 'Chọn',
  product_advance_search: 'Nâng cao',
  product_advance_search_between: 'Giữa',
  product_advance_search_please_select_one: 'Vui lòng chọn một mục',
  product_advance_search_stock: 'Kho hàng',
  product_advance_search_price: 'Giá',
  validatefail_price: 'Vui lòng chỉ nhập số không quá 2 chữ số',
  validatefail_stock: 'Vui lòng chỉ nhập số.',
  validatefail_normal_price: 'Sai giá sản phẩm thông thường',
  validatefail_member_price: 'Sai giá sản phẩm thành viên',
  validatefail_special_price: 'Sai giá sản phẩm khuyến mãi',
  validatefail_staticurl_dup: 'Sai mã URL tĩnh',
  validatefail_staticurl_format: 'Định dạng không hợp lệ. Vui lòng chỉ nhập chữ hoặc số hoặc - và không có khoảng trắng trong mã URL tĩnh.',
  validatefail_productRelateSearch: 'Vui lòng nhập tên sản phẩm với hơn 1 ký tự',
  validatefail_weight: 'Sai trọng lượng sản phẩm',
  validatefail_normal_price_lower_than_special: 'Normal Price must greater than Special Price',
  validatefail_normal_price_lower_than_member: 'Normal Price must greater than Member Price',
  validatefail_special_price_greater_than_normal: 'Special Price must not greater than Normal Price',
  validatefail_member_price_greater_than_normal: 'Member Price must not greater than Normal Price',
  validatefail_special_and_member_price_greater_than_normal: 'Normal Price must greater than Special Price and Member Price',
  modal_confirm_del: 'Xác nhận xóa sản phẩm?',
  modal_confirm_del_contact_form: 'Xác nhận xóa mẫu liên hệ',
  modal_confirm_del_contact_form_field: 'Xác nhận xóa mẫu liên hệ',
  modal_confirm_del_field: 'Xác nhận xóa mẫu đơn đặt hàng ',
  modal_confirm_del_payment_field: 'Xác nhận xóa phương thức thanh toán?',
  modal_confirm_del_velaeasy_sections: 'Sản phẩm này có phần nội dung thuộc hệ thống R-Web. Nếu bạn xóa sản phẩm này. Nội dung này cũng sẽ bị xóa <br><br> Xác nhận xóa sản phẩm?',
  modal_confirm_del_shipping_type: 'Xác nhận xóa lựa chọn giao hàng?',
  modal_delete_category_dialog_velaeasy_sections: 'Hạng mục này có phần nội dung thuộc hệ thống R-Web. Nếu bạn xóa hạng mục này, phần nội dung cũng sẽ bị xóa. <br><br> <br> bạn có chắc chắn muốn <b>xóa</b> <i>{name}</i>? <br> Hành động này không thể quay lại.',
  modal_confirm: 'Xác nhận',
  modal_cancel: 'Hủy',
  modal_success: 'Thành công',
  modal_success_del: 'Xóa sản phẩm thành công.',
  modal_success_del_contact_form: 'Xóa thông tin liên lạc thành công',
  modal_success_del_field: 'Xóa mẫu đơn hàng tùy chỉnh thành công',
  modal_success_del_payment_field: 'Xóa vùng thanh toán thành công',
  modal_success_del_shipping_type: 'Xóa hình thức giao hàng thành công',
  modal_error_occured: 'Có lỗi xảy ra! Vui lòng thử lại sau.',
  modal_fail_apply_all: 'Do not use empty normal price to apply all in this page',
  modal_fail: 'Vui lòng kiểm tra lại dữ liệu sản phẩm.',
  modal_fail_processing_static_url_input: 'Một dữ liệu URL tĩnh đang được xử lý. Vui lòng thử lại sau. ',
  modal_fail_processing_sku_input: 'Một dữ liệu SKU đang được xử lý. Vui lòng thử lại sau. ',
  modal_cancel_update: 'Bạn sắp thoát mà chưa lưu. Bạn có muốn lưu lại thay đổi?',
  modal_dont_save: 'Không lưu',
  modal_apply_to_all: 'Yes, Apply to all',
  modal_delete: 'Bạn có muốn xóa sản phẩm này?',
  modal_image_limit: 'Bạn chỉ có thể tải ảnh có độ lớn đến',
  modal_image_items: 'mặt hàng',
  modal_image_crop_limit: 'Bạn chỉ có thể tải một ảnh mỗi lần.',
  modal_disabled_product_variants: 'Vui lòng lưu sản phẩm trước khi truy cập cài đặt này.',
  modal_confirm_generate: 'Tạo thuộc tính mới?',
  modal_confirm_generate_alert: 'Thuộc tính sẽ bị xóa để tạo mới',
  modal_generating: 'Vui lòng đợi trong giây lát và không đóng ứng dụng.',
  modal_processing: 'Đang xử lý',
  modal_generate_complete: 'Khởi tạo thành công',
  modal_delete_product_var: 'Bạn có muốn xóa thuộc tính sản phẩm?',
  modal_delete_category_title: 'Xoá hạng mục',
  modal_delete_category_dialog: 'Bạn có chắc chắn muốn <b>xóa</b> <i>{name}</i>? <br>Hành động này không thể đảo ngược sau này.',
  modal_delete_category_cancel: 'Hủy',
  modal_delete_category_confirm: 'Xóa',
  modal_delete_category_fail: 'Xóa hạng mục không thành công. Hạng mục này đã có hạng mục con. Vui lòng xóa hạng mục con hoặc xóa sản phẩm.',
  modal_delete_relate: 'Bạn có muốn xóa sản phẩm liên quan này?',
  modal_title_delete: 'Xóa',
  modal_fail_del: 'Khoông thể xóa do hạng mục đã có sản phẩm hoặc hạng mục con.',
  modal_title_logout: 'Đăng xuất',
  modal_title_clear: 'Xóa dữ liệu',
  modal_clear: 'Bạn có muốn xóa dữ liệu này không?',
  modal_logout: 'Bạn có đăng xuất?',
  modal_title_warning: 'Thông báo',
  modal_currency_not_support_some_payments: 'Bạn có muốn sử dụng đơn vị tiền tệ này và hủy các phương thức thanh toán được hỗ trợ kèm theo?',
  modal_quota_rpshop_products: 'Gói dịch vụ của bạn không thể thêm sản phẩm. <br> Bạn có muốn nâng cấp gói dịch vụ này không?',
  modal_quota_rpshop_product_variants: 'Gói dịch vụ của bạn không thể thêm thuộc tính sản phẩm. <br> Bạn có muốn nâng cấp gói dịch vụ này không?',
  modal_quota_contact_form: 'Gói dịch vụ của bạn không thể thêm vùng liên hệ <br> Bạn có muốn nâng cấp gói dịch vụ này không?',
  modal_confirm_to_toggle_all_country: 'Các vùng quốc gia được chọn sẽ được bỏ đi. Bạn có muốn tiếp tục?',
  modal_confirm_delete_shipping_region: 'ยืXác nhận xóa vùng giao hàng?',
  modal_delete_shipping_region_success: 'Delete shipping region success.',
  product_list_total: 'Tổng cộng {total} mặt hàng.',
  product_list_add_product: 'Thêm sản phẩm',
  product_list_name: 'Sản phẩm mới',
  product_list_normal_price: 'Giá',
  product_list_member_price: 'Giá dành cho thành viên',
  product_list_special_price: 'Giá đặc biệt',
  product_list_image: 'Hình ảnh',
  product_list_stock: 'Kho hàng',
  product_list_status: 'Tình trạng',
  product_list_status_show: 'Hiển thị',
  product_list_status_hide: 'Ẩn',
  product_list_status_show_member: 'Chỉ dành cho thành viên',
  product_list_action: 'Quản lý',
  product_list_search_product_not_found: 'Không tìm thấy sản phẩm',
  product_list_search_please_fill_keyword: 'Vui lòng nhập từ khóa với ít nhất 1 ký tự hoặc điền giá hoặc mã hàng ',
  product_list_search_please_fill_correct_price: 'Vui lòng kiểm tra lại giá đã nhập',
  product_list_category_deleted_complete: 'Xóa hạng mục thành công',
  product_list_category_cannot_deleted: 'Không thể xóa hạng mục',
  product_info_add_product: 'Thêm sản phẩm',
  product_info_edit_product: 'Sửa sản phẩm',
  product_info_basic_setting: 'Cài đặt cơ bản',
  product_info_product_variants: 'Thuộc tính sản phẩm',
  product_basic_setting_image: 'Hình ảnh',
  product_basic_setting_add_product_relate: 'Thêm sản phẩm liên quan',
  product_basic_setting_relate_add_product: 'Thêm sản phẩm',
  product_basic_setting_name: 'Tên sản phẩm',
  product_basic_setting_SKU: 'SKU',
  product_basic_setting_relate_search_product_name_n_sku: 'Tên sản phẩm, SKU',
  product_basic_setting_select_a_contact_form: 'Chọn mẫu thông tin liên lạc',
  product_basic_setting_validate_product_name_required: 'Vui lòng nhập tên sản phẩm',
  product_basic_setting_validate_contact_form_required: 'Vui lòng chọn một mẫu thông tin liên lạc.',
  product_basic_setting_validate_product_limit: 'Tên sản phẩm vượt quá 200 ký tự.',
  product_basic_setting_detail: 'Thông tin',
  product_basic_setting_normal_price: 'Giá',
  product_basic_setting_original_price: 'Normal Price',
  product_basic_setting_special_price: 'Giá ưu đãi',
  product_basic_setting_member_price: 'Giá thành viên',
  product_basic_setting_discount_percentage: 'Discount {percent} % from normal price',
  product_basic_setting_staticURL: 'URL tĩnh',
  product_basic_setting_stock: 'Kho hàng',
  product_basic_setting_status: 'Tình trạng',
  product_basic_setting_status_show: 'Hiển thị',
  product_basic_setting_status_hide: 'Ẩn',
  product_basic_setting_status_show_only_members: 'Chỉ hiển thị cho thành viên',
  product_basic_setting_product_group: 'Nhóm sản phẩm',
  product_basic_setting_relate_search_no_result: 'Không kết quả',
  product_basic_setting_related_product: 'Sản phẩm liên quan',
  product_basic_setting_related_products: 'Sản phẩm liên quan',
  product_basic_setting_validate_sku_required: 'Vui lòng nhập SKU',
  product_basic_setting_validate_sku_duplicate: 'SKU trùng',
  product_basic_setting_validate_sku_limit: 'SKU vượt quá 255 ký tự',
  product_basic_setting_validate_sku_specialchar: 'Không được có ký tự đặc biệt',
  product_basic_setting_order_style: 'Vui lòng chọn hình thức mua hàng/ mẫu liên hệ cho sản phẩm này.',
  product_basic_setting_order_style_buy_now_button: 'Nút Mua ngay',
  product_basic_setting_order_style_contact_form: 'Mẫu liên hệ',
  product_basic_setting_order_style_hide_quantity_selection: 'Không lựa chọn hiển thị số lượng',
  product_basic_setting_order_style_hide_price: 'Ẩn giá',
  product_basic_setting_weight: 'Trọng lượng (g)',
  product_basic_setting_label: 'Label',
  product_basic_setting_product_label_new: 'New',
  product_basic_setting_product_label_best_seller: 'Best Seller',
  product_basic_setting_product_label_recommended: 'Recommended',
  product_variant_attribute: 'Thuộc tính',
  product_variant_attribute_values: 'Giá trị thuộc tính',
  product_variant_generate: 'Khởi tạo',
  product_variant_selectall: 'Chọn tất cả',
  product_variant_name: 'Tên',
  product_variant_image: 'Hình ảnh',
  product_variant_normal_price: 'Giá',
  product_variant_special_price: 'Giá ưu đãi',
  product_variant_member_price: 'Giá thành viên',
  product_variant_stock: 'Kho hàng',
  product_variant_status: 'Tình trạng',
  product_variant_action: 'Quản lý',
  product_variant_weight: 'Trọng lượng',
  product_variant_weight_g: 'g',
  product_variant_weight_tips: 'product\'s weight will be used when this field is blank',
  product_variant_validate_weight_incorrect: 'Please enter only numbers',
  product_variant_validate_weight_limit_exceed: 'Weight limit exceed {limit}',
  product_variant_validate_stock_incorrect: 'Please enter only numbers',
  product_variant_validate_sku_required: 'Vui lòng nhập SKU',
  product_variant_validate_sku_duplicate: 'SKU trùng',
  product_variant_validate_sku_limit: 'SKU vượt quá 255 ký tự',
  product_variant_status_show: 'Hiển thị',
  product_variant_status_hide: 'Ẩn',
  product_variant_status_out: 'Hết hàng',
  product_variant_delete: 'Xóa',
  product_variant_selected: 'Đã lựa chọn:',
  product_variant_deleteall: 'Xóa tất cả',
  product_variant_placeholder_attr: 'Ví dụ. Kích thước / Màu sắc',
  product_variant_product_attribute_add_a_tag: 'Ví dụ. Kích thước / Màu sắc',
  product_variant_placeholder_color_attr: 'e.g. Color',
  product_variant_product_attribute_color_add_a_tag: 'e.g. Red, Blue, Green',
  product_variant_placeholder_type_attr: 'e.g. Type',
  product_variant_product_attribute_type_add_a_tag: 'e.g. T-Shirt, Polo, Shirt',
  product_variant_SKU: 'SKU',
  product_variant_update_success: 'Cập nhật thành công',
  // product_variant_popper_apply_to_all: 'Áp dụng cho tất cả',
  product_variant_popper_apply_to_all: 'Apply to all on this page',
  product_variant_apply_to_all_question: 'Bạn có muốn áp dụng cho tất cả {field} ?',
  product_variant_attribute_generate_error: 'Vui lòng nhập đầy đủ trước khi khởi tạo',
  product_variant_attribute_generate_title: 'Xác nhận khởi tạo',
  product_variant_attribute_generate_message: 'Xóa tất cả sản phẩm cũ và tạo sản phẩm mới',
  product_variant_attribute_generate_add_success: 'Save successful',
  product_variant_attribute_generate_add_error: 'Khởi tạo thất bại',
  product_variant_attribute_generate_add_error_or_limit_over_1000: 'Không thể khởi tạo sản phẩm có nhiều hơn 1,000 mặt hàng thuộc tính.',
  product_variant_attribute_not_allow_brackets: 'Not allow "[" and "]"',
  currency_settings: 'Đơn vị tiền tệ',
  setting: 'Cài đặt',
  setting_currency: 'Đơn vị tiền tệ hiển thị',
  setting_currency_iso: 'ISO 4217 Mã tiền tệ hiển thị',
  setting_currency_iso_validate_required: 'Vui lòng chọn đơn vị tiền tệ',
  setting_currency_custom: 'Tùy chỉnh',
  setting_currency_custom_validate_required: 'Vui lòng nhập đầy đủ đơn vị tiền tệ',
  setting_currency_custom_validate_limit: 'Đơn vị tiền tệ tối đa 10 ký tự',
  setting_currency_preview: 'Xem trước',
  setting_currency_prefix: 'Trước ',
  setting_currency_suffix: 'Sau',
  shipping_settings: 'Phí giao hàng',
  shipping_settings_delete: 'Xóa',
  shipping_settings_add: 'Thêm khu vực mới',
  shipping_settings_empty_list: 'Không giao hàng',
  shipping_settings_delete_title: 'Xóa giao hàng',
  shipping_settings_delete_dialog: 'Bạn có muốn <b>xóa</b> giao hàng này ?',
  shipping_settings_edit_title: 'Sửa giao hàng',
  shipping_settings_toast_save_complete: 'Lưu thành công',
  shipping_settings_toast_delete_complete: 'Xóa thành công',
  shipping_validate_name_failed: 'Vui lòng nhập tên giao hàng',
  shipping_validate_name_failed_limit: 'Tên vượt quá 100 ký tự',
  shipping_validate_price_failed: 'Vui lòng nhập giá dưới dạng chữ số',
  shopping_cart_text_settings: 'Ghí chú trong giỏ hàng',
  shopping_cart_text_settings_cart: 'Giỏ hàng',
  shopping_cart_text_settings_thankyou: 'Trang cám ơn',
  shopping_cart_text_settings_cancel: 'Khôi phục dữ liệu gần đây',
  shopping_cart_text_settings_cancel_message: 'Dữ liệu chưa lưu sẽ bị mất, bạn có muốn tiếp tục?',
  payment_settings: 'Thanh toán',
  payment_settings_validate_omise_public_key: 'Vui lòng nhập từ khóa công khai',
  payment_settings_validate_omise_secret_key: 'Vui lòng nhập từ khóa ẩn',
  payment_settings_validate_paypal_client_id: 'Vui lòng nhập ID khách hàng',
  payment_settings_validate_paypal_secret: 'Vui lòng nhập',
  payment_settings_validate_transfer_manual_text: 'Vui lòng nhập danh mục tùy chỉnh',
  payment_settings_validate_custom_text: 'Vui lòng nhập văn bản',
  payment_settings_validate_kpayment_merchant_id: 'Please insert Merchant ID',
  payment_settings_validate_kpayment_public_key: 'Please insert Public key',
  payment_settings_validate_kpayment_secret_key: 'Please insert Secret key',
  payment_settings_currency: 'Đơn vị tiền tệ',
  payment_settings_currency_not_support: 'Không thể kích hoạt phương thức thanh toán với loại tiền tệ đã chọn. ',
  payment_settings_currency_display: 'Hiển thị',
  payment_settings_currency_position: 'Vị trí',
  payment_settings_currency_symbol: 'Ký tự',
  payment_settings_currency_prefix: 'Trước ',
  payment_settings_currency_suffix: 'Sau ',
  payment_settings_transfer: 'Chuyển khoản',
  payment_settings_transfer_title: 'Chuyển khoản',
  payment_settings_transfer_text: 'Hiển thị nội dung',
  payment_settings_transfer_custom: 'Tùy chỉnh',
  payment_settings_transfer_edit: 'Chỉnh sửa chuyển khoản',
  payment_settings_omise_edit: 'Chỉnh sửa Omise',
  payment_settings_paypal_edit: 'Chỉnh sửa PayPal',
  payment_settings_credit_card_edit: 'Edit Credit Card',
  payment_settings_qr_code_edit: 'Edit QR Code',
  payment_settings_kpayment_card_edit: 'Chỉnh sửa K-Payment Gateway',
  payment_settings_kpayment_use_same_config: 'This settings will affect both Credit Card and QR code payment',
  payment_settings_kpayment_use_with_bank: 'Use for register with the bank',
  payment_settings_kpayment_system_info: 'System information',
  payment_settings_kpayment_system_info_email: 'Developers\'s email',
  payment_settings_manual: 'Tự chỉnh',
  payment_settings_title: 'Cài đặt thanh toán',
  payment_settings_display_title: 'Phương thức thanh toán',
  payment_settings_edit_to_connect: 'Để kết nối',
  payment_settings_as_a_payment_method: 'như một hình thức thanh toán, tạo tài khoản hoàn tất',
  payment_settings_as_a_payment_method_please_choose: 'như một hình thức thanh toán, tạo tài khoản hoàn tất',
  payment_settings_custom_text: 'Nội dung',
  payment_settings_custom_icon: 'Icon',
  payment_settings_custom_no_icon: 'Không icon',
  payment_settings_field_limit_5: 'Vùng thanh toán đã đat giới hạn 5',
  export_order_error_title: 'Xuất thất bại',
  export_order_error_content: 'Thông tin yêu cầu xuất không được tim thấy hoặc vượt quá 1000 dữ liệu',
  export_order_confirm_title: 'Xác nhận để xuất đơn hàng',
  export_order_default: 'Xuất tất cả đơn hàng',
  export_order_date1: 'Ngày bắt đầu ',
  export_order_date2: 'Ngày kết thúc',
  export_order_keyword: 'Từ khóa',
  export_order_create_date: 'Create Date',
  export_order_update_date: 'Order Date',
  export_order_type: 'Type',
  export_order_status: 'Status',
  cc_email_settings: 'Email nhà cung cấp',
  cc_email_settings_send_order_email_to_address: 'Gửi đơn hàng đến địa chỉ email',
  cc_email_settings_main_email: 'Email chính',
  cc_email_settings_cc_email_1: 'CC Email 1',
  cc_email_settings_cc_email_2: 'CC Email 2',
  cc_email_settings_cc_email_3: 'CC Email 3',
  cc_email_settings_cc_email_4: 'CC Email 4',
  cc_email_settings_validate_required: 'Vui lòng nhập email chính',
  cc_email_settings_validate_invalid: 'Định dạng email không khả dụng',
  cc_email_settings_validate_duplicate: 'Trùng Email',
  order_custom_form_settings: 'Mẫu đơn hàng',
  order_custom_form_settings_title: 'Thiết lập tùy chỉnh cho mẫu đơn hàng của bạn',
  order_custom_form_display_title: 'Thông tin khác',
  order_custom_form_required_field: 'Ô thông tin bắt buộc nhập',
  order_custom_form_option_field: 'Ô thông tin tùy chọn nhập',
  order_details_custom_form: 'Thông tin đơn hàng khác',
  order_details_contact_form: 'Thông tin mẫu liên hệ khác',
  order_custom_form_option_field_limit: 'Số ô thông tin đã đạt giới hạn cho phép là {limit}',
  order_custom_form_attachment_field_limit: 'Tập tin đính kèm đã đạt giới hạn cho phép là {limit}',
  order_custom_form_label: 'Nhãn',
  order_custom_form_field_type: 'Loại hình',
  order_custom_form_text: 'Nội dung',
  order_custom_form_dropdown: 'Sổ xuống',
  order_custom_form_require: 'Bắt buộc',
  order_custom_form_dropdown_options: 'Lựa chọn',
  order_custom_form_text_placeholder: 'Mẫu tin nhắn',
  order_custom_form_dropdown_append: 'Thêm',
  order_custom_form_dropdown_replace: 'Thay thế',
  order_custom_form_no_item: 'Không có lựa chọn nào',
  order_custom_form_plase_upload_csv_file: 'Vui lòng tải lên tập tin CSV',
  order_custom_form_setting_not_found: 'Không tìm thấy vùng tùy chọn',
  order_custom_form_option_is_null: 'Không có dữ liệu',
  order_custom_form_option_over: 'Dữ liệu vượt quá {limit} mặt hàng.',
  order_custom_form_please_insert_label: 'Vui lòng nhập một nhãn',
  order_custom_form_please_add_options: 'Vui lòng thêm lựa chọn',
  order_custom_form_option_character_over: 'Một số lựa chon kích thước vượt quá {limit} kí tự.',
  order_custom_form_option_duplicate: 'Trùng giá trị',
  order_custom_form_datetime_show_time: 'Thời gian hiển thị',
  update_products_sorting_toast_complete: 'Lưu thành công',
  update_products_sorting_toast_error: 'Có lỗi xảy ra! Vui lòng thử lại sau.',
  category_products_sort_label: 'Sort by',
  sort_options_custom: 'Custom',
  sort_options_newest: 'Mới nhất',
  sort_options_oldest: 'Cũ nhất',
  sort_options_a_to_z: 'A-Z',
  sort_options_z_to_a: 'Z-A',
  sort_options_highest_price: 'Giá cao nhất',
  sort_options_lowest_price: 'Giá thấp nhất',
  sort_options_confirm_title: 'Lọc tất cả sàn phẩm',
  sort_options_confirm_detail: 'Hành động này sẽ <b>cập nhật</b> đơn hàng sản phẩm hiện tại của bạn. Bạn có muốn tiếp tục không?',
  no_sub_category: 'Không có hạng mục con',
  pinned_products_sortable_hint: 'Các sản phẩm được ghim có thể kéo thay đổi vị trí',
  all_products_sort_label: 'Tất cả sản phẩm đã được lọc',
  unpin_product_title: 'Bỏ ghim sản phẩm',
  unpin_product_dialog: 'Bạn có muốn bỏ ghim sản phẩm?',
  contact_form_settings: 'Mẫu liên hệ',
  contact_form_settings_title: 'Cài đặt mẫu ',
  contact_form_setting_not_found: 'Không tìm thấy mẫu liên hệ',
  contact_form_name: 'Tên',
  contact_form_please_insert_name: 'Vui lòng nhập tên',
  contact_form_settings_field: 'Cài đặt vùng liên hệ cho mẫu liên hệ của bạn',
  contact_form_setting_field_not_found: 'Không tìm thấy vùng liên hệ',
  contact_form_display_title: 'Mẫu',
  contact_form_settings_detail: 'Liên hệ với khách hàng trước khi hoàn tất mua hàng',
  contact_form_setting_untitle: 'Không tiêu đề',
  contact_form_setting_create: 'Tạo mẫu liên hệ',
  contact_form_label: 'Nhãn',
  contact_form_please_insert_label: 'Vui lòng nhập một nhãn',
  contact_form_please_insert_text: 'Vui lòng nhập nội dung',
  contact_form_field_type: 'Loại hình',
  contact_form_text: 'Nội dung',
  contact_form_email: 'Email',
  contact_form_tel: 'Số điện thoại',
  contact_form_dropdown: 'Sổ xuống',
  contact_form_textarea: 'Văn bản',
  contact_form_checkbox: 'Ô đánh dấu',
  contact_form_radio: 'Chọn được 1 lựa chọn',
  contact_form_attachment: 'Đính kèm',
  contact_form_date: 'Ngày',
  contact_form_datetime: 'Ngày giờ',
  contact_form_text_placeholder: 'Mẫu tin nhắn',
  contact_form_dropdown_options: 'Lựa chọn',
  contact_form_no_item: 'Không có mặt hàng nào',
  contact_form_require: 'Bắt buộc',
  contact_form_option_over: 'Dữ liệu nhiều hơn {limit} mặt hàng.',
  contact_form_option_duplicate: 'Trùng giá trị',
  contact_form_please_add_options: 'Vui lòng thêm lựa chọn.',
  contact_form_dropdown_append: 'Thêm',
  contact_form_dropdown_replace: 'Thay thế',
  contact_form_option_character_over: 'Một số lựa chọn kích thước vượt quá {limit} ký tự.',
  contact_form_option_is_null: 'Dữ liệu trống.',
  contact_form_plase_upload_csv_file: 'Vui lòng tải tập tin CSV.',
  contact_form_setting_button_contact: 'Liên hệ',
  contact_form_setting_button_reserve: 'Đặt trước',
  contact_form_setting_button_buy_now: 'Mua ngay',
  contact_form_settings_button: 'Nút lưu',
  contact_form_button_icon: 'Icon',
  contact_form_button_no_icon: 'Không có',
  contact_form_option_field_limit: 'Số ô thông tin đã đạt giới hạn cho phép là {limit}',
  contact_form_attachment_field_limit: 'Tập tin đính kèm đã đạt giới hạn cho phép là {limit}',
  contact_form_datetime_show_time: 'Thời gian hiển thị',
  form_settings: 'Mẫu',
  form_settings_detail: 'Tạo mẫu đơn cho khách hàng hoàn tất khi mua hàng hoặc liên hệ.',
  form_settings_shipping: 'Tạo hình thức vận chuyển',
  shipping_region_settings_back_to_list_of_regions: 'Trở lại',
  shipping_region_settings_shipping_region: 'Vùng giao hàng',
  shipping_region_settings_add_country_in_this_region: 'thêm quốc qua vào vùng này.',
  shipping_region_settings_shipping_type: 'Phương thức giao hàng',
  shipping_region_settings_add_shipping_type_in_this_region: 'Thêm phương thức giao hàng vào vùng này. ',
  shipping_region_settings_add_shipping_type: 'Thêm phương thức giao hàng',
  shipping_estimate_delivery_time: 'Ước tính thời gian giao hàng ',
  shipping_estimate_delivery_time_placeholder: 'Ví dụ. 2-10 ngày làm việc',
  shipping_name: 'Tên',
  shipping_name_placeholder: 'Ex. Miễn phí giao hàng',
  shipping_description: 'Mô tả',
  shipping_description_placeholder: 'Ví dụ. Miễn phí giao hàng cho đơn hàng hợp lệ',
  shipping_limit_input: 'Giới hạn {limit} ký tự',
  shipping_type: 'Phương thức giao hàng',
  shipping_type_free_shipping: 'Giao hàng miễn phí',
  shipping_description_free_shipping: 'Không tính phí giao hàng cho khách hàng của bạn',
  shipping_type_flat_rate: 'Cước phí cố định',
  shipping_description_flat_rate: 'Áp dụng chung một mức phí cho tất cả đơn hàng',
  shipping_type_rate_by_quantity: 'Cước phí tính theo số lượng',
  shipping_description_rate_by_quantity: 'Cước phí được tính dựa vào tổng số lượng sản phẩm trong đơn hàng',
  shipping_type_rate_by_weight: 'Cước phí theo trọng lượng',
  shipping_description_rate_by_weight: 'Cước phí được tính dựa vào trọng lượng sản phẩm trong đơn hàng',
  shipping_type_external: 'Tính phí giao hàng riêng',
  shipping_description_external: 'Tính thêm phí giao hàng sau khi đặt hàng',
  shipping_shop_free: 'Miễn phí',
  region_country_selector: 'Chọn quốc gia',
  all_country: 'All countries except countries that specify in shipping area',
  add_country: '+ Thêm quốc gia',
  select_country: 'Chọn quốc gia',
  no_country_result: 'Không tìm thấy quốc gia',
  shipping_region_limit_over: 'Vùng giao hàng đã đạt mức giới hạn  {limit}',
  shipping_settings_free_order: 'Miễn phí giao hàng cho đơn hàng trên {rate}',
  shipping_offer_free_shipping: 'Miễn phí giao hàng cho đơn hàng có giá trị theo quy định',
  shipping_item_limit_over: 'Phương thức giao hàng đã đạt giới hạn {limit} hình thức ',
  shipping_quantity_range: 'Phạm vi số lượng',
  shipping_weight_range: 'Khoảng trọng lượng (g)',
  shipping_rate: 'Cước phí',
  shipping_add_range: 'Thêm phạm vi',
  shipping_invalid_weight_data: 'Phạm vi số lượng và cước phí không khả dụng',
  shipping_invalid_quantity_data: 'Phạm vi trọng lượng và cước phí không khả dụng',
  shipping_invalid_quantity_range: 'Phạm vi số lượng không khả dụng',
  shipping_invalid_weight_range: 'Phạm vi trọng lượng không khả dụng',
  shipping_invalid_rate: 'Phạm vi cước phí không khả dụng',
  shipping_invalid_offer_free_shipping_rate: 'Invalid price',
  shipping_and_more_range: 'và trên ',
  shipping_range_limit: 'Giới hạn phạm vi {limit}',
  shipping_rate_placeholder: 'Ví dụ. 1000.00',
  shipping_require_name: 'Vui lòng thêm tên phương thức giao hàng',
  shipping_invalid_data: 'Dữ liệu không khả dụng',
  shipping_region_list_setting: 'Danh sách vùng giao hàng',
  payment_not_support_feature: 'Gói hiện tại của bạn không thể sử dụng tính năng này.',
  accept_credit_card: 'Accept Credit Cards',
  paypal: 'PayPal',
  omise: 'Omise',
  rshop_manual: 'Hướng dẫn sử dụng R-Shop',
  menu_export: 'Export',
  tooltip_menu_export: 'Export Purchase Order',
  tooltip_menu_order: 'Manage Order Status',
  tooltip_menu_product: 'Manage Products',
  tooltip_menu_setting: 'System Settings',
  order_pointspot_discount: 'Discounts from Pointspot',
  shipping_area_defined: 'Set shipping area',
  shipping_area_other: 'Other area',
  shipping_courntry_type: 'Country',
  shipping_thai_province_type: 'Provinces in Thailand',
  other_country: 'Other countries',
  other_thai_province: 'Other provinces in Thailand',
  shipping_other_area_all_province: 'All provinces except provinces that specify shipping area',
  shipping_area_type: 'Shipping area type',
  country_name_list: 'Countries name list',
  province_name_list: 'Provinces name list',
  select_province: 'Select province',
  no_province_result: 'No provinces found',
  display_not_specify: 'Not specify',
  change_shipping_type_confirm_description: 'Confirm to change shipping area type from <b>[change_from]</b> to <b>[change_to]</b>',
  order_pointspot_receive_point: 'Points received from Pointspot',
  sorting_option_setting: 'Sorting',
  sorting_option_product_category: 'Product Category',
  sorting_option_product: 'Product',
  sorting_option_sort_by: 'Sort by',
  edit_product_sorting: 'Edit products sorting',
  edit_category_sorting: 'Edit product categories sorting',
  affect_to_label: 'Affect to',
  all_products_list: 'All products list',
  new_products_list: 'New products list',
  all_category_list: 'All categories list',
  new_category_list: 'New categories list',
  all_categories_sort_label: 'Sort by',
  sort_category: 'Sort category',
  publish_sort_category_action_suggest: 'Apply these changes to your website',
  publish_sort_category_btn: 'Publish',
  product_advance_search_status: 'Status',
  product_advance_search_status_show: 'Show',
  product_advance_search_status_hide: 'Hide',
  not_defined: 'None',
  products_card_move_to_first: 'Move to first',
  products_card_move_to_last: 'Move to last',
  products_card_move_to_specific_target: 'Move to specific target',
  products_sorting_waiting_to_publish: 'Apply these changes to your website',
  products_in_this_category_label: 'Only this category',
  products_under_category_label: 'Include sub categories',
  sort_product_btn: 'Sort Product',
  no_category_childs_label: 'Category not found under this category',
  products_card_move_after: 'Move after',
  error_product_order_range: 'Please specific order from 1 - {max}',
  product_sorting_title: 'Product Sorting',
  product_sorting_newest: 'New product to old product',
  product_sorting_oldest: 'Old product to new product',
  product_sorting_name_asc: 'Product name A-Z',
  product_sorting_name_desc: 'Product name Z-A',
  product_sorting_price_asc: 'Product price low to high',
  product_sorting_price_desc: 'Product price high to low',
  category_sorting_newest: 'New category to old category',
  category_sorting_oldest: 'Old category to new category',
  category_sorting_name_asc: 'Category name A-Z',
  category_sorting_name_desc: 'Category name Z-A',
  product_filter_max: 'Not Exceeded',
  product_filter_min: '',
  product_filter_equal: 'Equals',
  upload_image_multiple_select: 'Multiple images at once.',
  upload_image_multiple_recommend_image_size: 'Recommended image size is {image_size}.',
  upload_image_multiple_recommend_file_size: 'File size not exceed {file_size}.',
  upload_image_multiple_max_number_of_files: 'Maximum {number} images.',
  payment_method_type_transfer: 'Transfer',
  payment_method_type_cash: 'Cash on Delivery',
  payment_method_type_other: 'Others',
  payment_setting_type: 'Type',
  payment_setting_channel: 'Channel',
  payment_setting_methods: 'Methods',
  payment_setting_channel_placeholder: 'Bank Name / Account No',
  payment_setting_description: 'Description',
  payment_setting_description_placeholder: 'Account Name / More Details',
  payment_setting_show_payment_evidence: 'Show Payment Evidence Button',
  payment_setting_show_payment_evidence_yes: 'Yes',
  payment_setting_show_payment_evidence_no: 'No',
  cannot_remove_last_image: 'Can\'t delete last image',
  shipping_pricing: 'Pricing',
  shipping_service: 'Shipping services',
  product_variant_image_upload_not_save: 'Please save your product before upload images.',
  order_update_date: 'Update Date',
  order_status: 'Status',
  order_type_merchant: 'Merchant',
  order_status_new: 'New',
  order_status_confirm: 'Pending',
  order_status_paid: 'Paid',
  order_status_delivering: 'Delivering',
  order_status_delivered: 'Delivered',
  order_advance_search_between: 'Between',
  btn_add_order: 'Add order',
  order_status_detail: 'Order Status',
  order_tracking_number: 'Tracking Number',
  order_delivered_date: 'Delivered on',
  order_check_tracking: 'Check',
  new_order_header: 'Create Order',
  edit_order_header: 'Edit Order',
  order_url: 'Order Url',
  order_district: 'District',
  order_sub_district: 'Sub District',
  btn_new_order_save: 'Save',
  add_new_product: 'Add new products',
  add_product_search: 'Product name, Product SKU',
  add_product_successful: 'Add product successful',
  add_product_failed: 'This product is already added',
  add_new_order_alert: 'Please add at least 1 product',
  order_address_line2: 'Address 2',
  btn_copy_order_url: 'Copy order URL',
  alert_copy_success: 'Copied success',
  validatefail_product_sales_value: 'Incorrect default value',
  product_sales_label: 'Products Sold',
  product_sold_label: 'Sold',
  product_sold_display: 'Display value',
  not_add_product_label: 'No product added yet',
  product_sold_default_label: 'Default',
  menu_order_list: 'Orders',
  tooltip_menu_order_list: 'Order List',
  add_new_product_search_alert_label: 'Please enter the keyword',
  label_order_country_select: 'Select Country',
  label_order_province_select: 'Select Province',
  label_order_district_select: 'Select District',
  label_order_sub_district_select: 'Select Sub District',
  label_btn_delete_product_mobile: 'Delete Product',
  label_total_product_product_mobile: 'Total',
  label_btn_create_in_chat_order: 'Create In-Chat Order',
  label_in_chat_order: 'In-Chat Order',
  label_normal: 'Normal',
  label_btn_copy_order_in_chat_url: 'Copy Order URL In-Chat',
  label_address_toggle: 'Address Information',
  label_product_over_stock_alert: 'Product quantity is not enough',
  order_total_table: 'Grand Total',
  order_total_table_header: 'Total',
  error_product_order_variant_empty: 'Please specific product variant',
  order_address_line1: 'Address',
  label_product_over_stock_alert_not_correct: 'Please specific product quantity',
  pricing_model_per_unit: 'Per unit',
  pricing_model_tier: 'Tiered',
  pricing_model_unit: 'Unit pricing',
  pricing_model_volume: 'Volume pricing',
  label_pricing_model: 'Pricing Model',
  pricing_volume_range: 'Quantity',
  pricing_tier_range: 'Quantity',
  above: 'Above',
  edit_order_status: 'Edit Order Status',
  open_rcrm_order_detail: 'View Detail',
  product_step_price_add_range: 'Add range',
  price_volume_variants_affected_warning: 'Product variants will be affected by volume price settings automatically',
  price_volume_range_error_message: 'Invalid quantity range',
  price_volume_prices_error_message: 'Invalid price',
  order_details: 'Order',
  not_specified: 'Not specified',
  product_list_product_variants: 'Have product variants',
  variant_setting_title_change_page_modal: 'Are you changing page without save ?',
  variant_setting_title_change_tab_modal: 'Are you changing menu tab without save ?',
  variant_setting_confirm_change_page_modal: 'Yes, Don\'t save',
  save_basic_setting_button: 'Save Basic settings',
  save_variant_setting_button: 'Save Variants',
  add_new_order_quantity_alert: 'Please verify Qty and total prices',
  product_under_category_over_limit: 'Please use standard product sorting.',
  product_image_modal_error_occured: 'Incorrect file type, please try again.'
}



// WEBPACK FOOTER //
// ./src/store/i18n/vi.js